/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchRecordUiAcknowledgementsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {BatchRecordUiAcknowledgementsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const batchRecordUiAcknowledgements = (request: BatchRecordUiAcknowledgementsRequest, options?: CashRequestOptions) => post<BatchRecordUiAcknowledgementsRequest, BatchRecordUiAcknowledgementsResponse>("/2.0/cash/batch-record-ui-acknowledgements", request, {...options, rejectOnError: true })